import React, { useState } from 'react';
import { connect } from 'react-redux';
import { selectFontFamilyById, updateFontFamilyByIds } from '../../_redux';
import { AppDispatch, WebsiteState } from '@gift/website-state/store';
import { FontFamilyDropdownMenu } from './FontFamilyDropdownMenu';
import { FontFamilyModal } from './FontFamilyModal';
import { Dropdown } from '@gift/ui/components/dropdown/Dropdown';
import { DropdownField } from '@gift/ui/components/dropdown/partials/DropdownField';
import { Mobile } from '@gift/ui/components/breakpoints/Mobile';
import { Desktop } from '@gift/ui/components/breakpoints/Desktop';

export const _FontFamilyDropdown = ({ selectedFontFamily, commit }: Props) => {
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);
    return (
        <Dropdown open={open} setOpen={setOpen}>
            <DropdownField onClick={toggle} active={open}>
                <span style={{ fontFamily: selectedFontFamily }}>
                    {selectedFontFamily}
                </span>
            </DropdownField>

            {open && (
                <>
                    <Mobile>
                        <FontFamilyModal
                            selectedFontFamily={selectedFontFamily}
                            commit={commit}
                            toggle={toggle} />
                    </Mobile>

                    <Desktop>
                        <FontFamilyDropdownMenu
                            selectedFontFamily={selectedFontFamily}
                            commit={commit}
                            toggle={toggle} />
                    </Desktop>
                </>
            )}
        </Dropdown>
    );
};

type Props = {
    variableIds: string[],
    selectedFontFamily: string,
    commit: (family: string) => void,
};

const mapStateToProps = (state: WebsiteState, ownProps: { variableIds: string[] }) => ({
    selectedFontFamily: selectFontFamilyById(state, ownProps.variableIds[0]!)!
});

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { variableIds: string[] }) => ({
    commit: (family: string) => dispatch(updateFontFamilyByIds(ownProps.variableIds, family)),
});

export const FontFamilyDropdown = connect(
    mapStateToProps,
    mapDispatchToProps
)(_FontFamilyDropdown);
